export const email = {
  email: {
    shape:
      '<path d="M18 16H2a2 2 0 0 1-2-2V1.913A2 2 0 0 1 2 0h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2ZM2 3.868V14h16V3.868L10 9.2 2 3.868ZM2.8 2 10 6.8 17.2 2H2.8Z" fill="#333" />',
    viewBox: [0, 0, 20, 16],
  },
};
